export default "__VITE_ASSET__B4_qYj9h__"